export default {
  API_ENDPOINT: 'https://guarded-fortress-39021.herokuapp.com/api'
}
